import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { useDmsUsersQuery } from "modules/UsersDashboard/components/PairUsers/hooks/useDmsUsersQuery";
import { useGetUsersDashboardFilters } from "modules/UsersDashboard/components/UsersDashboardFilters/hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { DMSUser } from "models";
import type { PairedUserState } from "modules/UsersDashboard/components/PairUsers";

const constructPayload = (pairedUsers: PairedUserState[], dmsUsers: DMSUser[] = []) =>
  pairedUsers.flatMap(({ pair_to, user_id }) => {
    const pairedUser = dmsUsers.find(dmsUser => dmsUser.dms_nr === String(pair_to));
    return pairedUser ? { ...pairedUser, user_id } : [];
  });

export const useUpdatePairDmsUsersMutation = (pairedUsers: PairedUserState[]) => {
  const {
    filters: { dealer_location_ids }
  } = useGetUsersDashboardFilters();
  const { data: dmsUsers } = useDmsUsersQuery(dealer_location_ids[0] ?? 0);

  return useTypedMutation<void, void>({
    mutationFn: async () => (await ApiInstance.post("/users/pairing/dms/update", { dms_users: constructPayload(pairedUsers, dmsUsers) }, ENV.systemBaseURL)).data,
    onSuccess: () => {
      const prevUsers = typedQueryClient.getQueryData(UsersDashboardQueryKeys.users);
      if (!prevUsers) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.users, {
        ...prevUsers,
        users: prevUsers.users.map(user => {
          const paired = pairedUsers.find(pairedUser => pairedUser.user_id === user.id);
          return paired ? { ...user, dms_nr: String(paired.pair_to) } : user;
        })
      });
    }
  });
};
